import { fetcher } from '../../lib/api-fetcher';
import type { SuretyRequestItem, SuretyRequestDetail, NomineeDocument, SuretyNominee } from './types.js';


export const suretyClient = {
  listRequests: async (params?: { schemeId?: string }) => {
    const qs = new URLSearchParams();
    if (params?.schemeId) {
      qs.append('schemeId', params.schemeId);
    }
    const url = `/staff/v1/surety-requests?${qs.toString()}`;
    const res = await fetcher.get<{ data: SuretyRequestItem[] } | SuretyRequestItem[]>(url);
    // NestJS controller returns a Result wrapper that unwraps or raw data.
    // If it's standard unwrapped: { data: [...] } or direct.
    // We handle both format styles safely.
    return (res && typeof res === 'object' && 'data' in res ? (res as Record<string, unknown>).data : res) as SuretyRequestItem[];
  },

  getRequestDetail: async (id: string) => {
    const res = await fetcher.get<{ data: SuretyRequestDetail } | SuretyRequestDetail>(`/staff/v1/surety-requests/${id}`);
    return (res && typeof res === 'object' && 'data' in res ? (res as Record<string, unknown>).data : res) as SuretyRequestDetail;
  },

  addNominee: async (id: string, body: { nomineeCustomerId: string; nomineeSubscriberId?: string }) => {
    const res = await fetcher.post<{ data: SuretyNominee } | SuretyNominee>(`/staff/v1/surety-requests/${id}/nominees`, body);
    return (res && typeof res === 'object' && 'data' in res ? (res as Record<string, unknown>).data : res) as SuretyNominee;
  },

  uploadDocuments: async (nomineeId: string, documents: NomineeDocument[]) => {
    const res = await fetcher.post<{ data: SuretyNominee } | SuretyNominee>(`/staff/v1/surety-requests/nominees/${nomineeId}/documents`, {
      documents,
    });
    return (res && typeof res === 'object' && 'data' in res ? (res as Record<string, unknown>).data : res) as SuretyNominee;
  },

  approveNominee: async (nomineeId: string) => {
    const res = await fetcher.post<{ data: SuretyNominee } | SuretyNominee>(`/staff/v1/surety-requests/nominees/${nomineeId}/approve`, {});
    return (res && typeof res === 'object' && 'data' in res ? (res as Record<string, unknown>).data : res) as SuretyNominee;
  },

  rejectNominee: async (nomineeId: string, rejectionReason: string) => {
    const res = await fetcher.post<{ data: SuretyNominee } | SuretyNominee>(`/staff/v1/surety-requests/nominees/${nomineeId}/reject`, {
      rejectionReason,
    });
    return (res && typeof res === 'object' && 'data' in res ? (res as Record<string, unknown>).data : res) as SuretyNominee;
  },
};
